module.exports = __webpack_public_path__ + "img/austria.f36d2dd5.jpg";